import script from "./ModuleDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleDetailsModal.vue?vue&type=style&index=0&id=b96fb2d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96fb2d4"]])

export default __exports__